// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  recipeId: __t.u64(),
  workspaceId: __t.option(__t.u64()),
  taskTag: __t.string(),
  receiptCount: __t.u32(),
  avgCostMicros: __t.i64(),
  avgLatencyMs: __t.u32(),
  acceptanceRate: __t.f32(),
  correctionRate: __t.f32(),
  ciPassRate: __t.f32(),
  watcherQuietness: __t.f32(),
};
